import { STTrendlineType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import i18n from '@i18next/i18n';
import { IChartDataItem } from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/data-item/data-item.interface';
import type {
    ITrendline,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/sub-chart-properties.interface';
import type {
    IChartShapeProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property.interface';
import {
    IChartSeries,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/sub-chart-properties.interface';

export interface ITrendlineProperty extends IChartShapeProperty, ITrendline {
    data: ITrendlineDataItem[]
    series: IChartSeries;
    isSupport: boolean;
    initTrendlineDataSource(dataSet: any): void;
}

export interface ITrendlineDataItem extends IChartDataItem {
    name: string;
}

// DataView支持的回归统计类型
export type RegressionType = 'linear' | 'exponential' | 'logarithmic' | 'power' | 'polynomial';
export const trendLineTypeMap: Partial<Record<STTrendlineType, RegressionType>> = {
    [STTrendlineType.linear]: 'linear',  // 线性
    [STTrendlineType.exp]: 'exponential',    // 指数
    [STTrendlineType.log]: 'logarithmic',    // 对数
    [STTrendlineType.power]: 'power',    // 乘幂
    [STTrendlineType.poly]: 'polynomial',    // 多项式
    // MOVING_AVG = 'movingAvg' //  g2暂不支持 移动平均
};

// 趋势线对应的名称
export const trendLineNameMap: Record<STTrendlineType, string> = {
    [STTrendlineType.linear]: i18n.t('线性') as string,
    [STTrendlineType.exp]: i18n.t('指数') as string,
    [STTrendlineType.log]: i18n.t('对数') as string,
    [STTrendlineType.power]: i18n.t('乘幂') as string,
    [STTrendlineType.poly]: i18n.t('多项式') as string,
    [STTrendlineType.movingAvg]: i18n.t('移动平均') as string,
    [STTrendlineType.PBDEFAULT]: '',
};
